import styled from 'styled-components';
import getContrastFontColor from '@utils/getContrastFontColor';
import { media } from 'styled-bootstrap-grid';

export const InfoBox = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  padding: 14px 12px;
  background: ${({ theme }) => `${theme.customColors.primary}`};
  width: max-content;
  ${media.md`
    max-width: 350px;
  `}
  height: 48px;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  z-index: 99;
  color: ${({ theme }) =>
    `${getContrastFontColor(theme.defaultColors.fontPrimary, theme.customColors.primary)}`};
`;

export const CloseButton = styled.button`
  background: none;
  border: 0;
  color: ${({ theme }) =>
    `${getContrastFontColor(theme.defaultColors.fontPrimary, theme.customColors.primary)}`};
  text-decoration: underline;
`;
